
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[exchange]/[ticker]/short-interest",
      function () {
        return require("private-next-pages/s/[exchange]/[ticker]/short-interest/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[exchange]/[ticker]/short-interest"])
      });
    }
  